import { lazyNamed } from 'src/utils/lazyNamed';

export const AdPrices = {
  List: lazyNamed(() => import('./containers/AdPricesList'), 'AdPricesList'),
  Form: lazyNamed(() => import('./containers/AdPriceForm'), 'AdPriceForm'),
  AdPriceHistory: lazyNamed(() => import('./containers/AdPriceHistory'), 'AdPriceHistory'),
};
